import React from "react";
import { connect } from "react-redux";
import {
  Modal,
  ModalBody,
  ModalHeader,
  TabContent,
  TabPane,
  NavLink as NavLinkUI,
  Nav,
  NavItem,
} from "reactstrap";
import axios from "axios";
import classnames from "classnames";
import ReactJson from "react-json-view";
import { loaderMaskActions, msgActions } from "../../../../../redux/actions";

function FileTechnicalModal({
  isTechnicalOldFile,
  dispatch,
  technicalModal,
  toggleTechnicalModal,
  filesBucketData,
  paramsForTechnicalData,
  filesBucketEventsData,
  filesBucketOrphansData,
  activeTab,

  setFilesBucketEventsData,
  setFilesBucketOrphansData,
  setActiveTab,
}) {
  const toggleTechnicalTab = async (tab) => {
    let params = paramsForTechnicalData;
    if (activeTab !== tab) {
      if (tab === "2" && !filesBucketEventsData) {
        try {
          dispatch(loaderMaskActions.show("Loading File Technicals..."));
          let response = await axios.get("Tracking/GetFilesBucketEvents", {
            params: params,
          });
          var json = response.data;
          if (json.Errors && json.Errors.length > 0) {
            dispatch(msgActions.error("File Bucket Events", json.Errors[0]));
            return;
          }
          let newFilesBucketEventsData = json.Data || {};
          setFilesBucketEventsData(newFilesBucketEventsData);
        } catch (error) {
          dispatch(msgActions.error("Loading File Technicals", error.message));
        } finally {
          dispatch(loaderMaskActions.hide(""));
        }
      }

      if (tab === "3" && !filesBucketOrphansData) {
        try {
          dispatch(loaderMaskActions.show("Loading File Technicals..."));
          let response = await axios.get("Tracking/GetFilesBucketOrphans", {
            params: params,
          });
          let json = response.data;
          if (json.Errors && json.Errors.length > 0) {
            dispatch(msgActions.error("File Bucket Orphans", json.Errors[0]));
            return;
          }
          let newFilesBucketOrphansData = json.Data || {};
          setFilesBucketOrphansData(newFilesBucketOrphansData);
        } catch (error) {
          dispatch(msgActions.error("Loading File Technicals", error.message));
        } finally {
          dispatch(loaderMaskActions.hide(""));
        }
      }
      setActiveTab(tab);
    }
  };

  return (
    <>
      <Modal
        style={{ width: "70vw", maxWidth: "95vw" }}
        isOpen={technicalModal}
        toggle={toggleTechnicalModal}
      >
        <ModalHeader toggle={toggleTechnicalModal}>Technical</ModalHeader>
        <ModalBody>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLinkUI
                  className={classnames({
                    active: activeTab === "1",
                  })}
                  onClick={() => {
                    toggleTechnicalTab("1");
                  }}
                >
                  Bucket
                </NavLinkUI>
              </NavItem>
              {!isTechnicalOldFile && (
                <NavItem>
                  <NavLinkUI
                    className={classnames({
                      active: activeTab === "2",
                    })}
                    onClick={() => {
                      toggleTechnicalTab("2");
                    }}
                  >
                    Events
                  </NavLinkUI>
                </NavItem>
              )}
              {!isTechnicalOldFile && (
                <NavItem>
                  <NavLinkUI
                    className={classnames({
                      active: activeTab === "3",
                    })}
                    onClick={() => {
                      toggleTechnicalTab("3");
                    }}
                  >
                    Orphans
                  </NavLinkUI>
                </NavItem>
              )}
            </Nav>
            <TabContent activeTab={activeTab} className="technical-tab-content">
              <TabPane tabId="1">
                <ReactJson displayDataTypes={false} src={filesBucketData} />
              </TabPane>
              {!isTechnicalOldFile && (
                <TabPane tabId="2">
                  <ReactJson
                    displayDataTypes={false}
                    src={filesBucketEventsData}
                  />
                </TabPane>
              )}
              {!isTechnicalOldFile && (
                <TabPane tabId="3">
                  <ReactJson
                    displayDataTypes={false}
                    src={filesBucketOrphansData}
                  />
                </TabPane>
              )}
            </TabContent>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  return {};
}

const connectedFileTechnicalModal =
  connect(mapStateToProps)(FileTechnicalModal);
export { connectedFileTechnicalModal as FileTechnicalModal };
